import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionAffectsSkinPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionAffectsSkin.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionAffectsSkin.button1'),
          value: 'stress',
        },
        {
          text: t('pages.onboarding.questionAffectsSkin.button2'),
          value: 'sleep',
        },
        {
          text: t('pages.onboarding.questionAffectsSkin.button3'),
          value: 'hormones',
        },
        {
          text: t('pages.onboarding.questionAffectsSkin.button4'),
          value: 'nutrition',
        },
        {
          text: t('pages.onboarding.questionAffectsSkin.button5'),
          value: 'pollution',
        },
        {
          text: t('pages.onboarding.questionAffectsSkin.button6'),
          value: 'not_sure',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
